export enum GameStatusEnum {
  BEFORE_STARTING,
  LOADING,
  RUNNING,
  PAUSED,
  WON,
  LOST,
  REVEALED,
  ERROR,
  STANDBY_WON,
  STANDBY_LOST,
}

export enum GameActionTypeEnum {
  FIND_NEW_POKEMON = 'FIND_NEW_POKEMON',
  CLICK_LETTER = 'CLICK_LETTER',
  UPDATE_STATUS = 'UPDATE_STATUS',
  CHANGE_GENERATION = 'CHANGE_GENERATION',
  RESET_GAME = 'RESET_GAME',
  REVEAL_NAME = 'REVEAL_NAME',
}
